var exports = {
  "Q": "x61f99309--bbfb3d--text",
};

module.exports = exports;
